import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import Countdown from "react-countdown-now";
import Renderer from "../../components/countdown/Renderer";

const CountDownThree = ({
  block
}) => {
  return (
    <div
      className={`funfact-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8 col-lg-6 order-1 order-lg-2">
            <div className="funfact-content funfact-res text-center">
              <h2 style={{ lineHeight: '48px'}}>{block?.title}</h2>
              <div className="timer">
                <Countdown date={new Date(block?.componentData?.date)} renderer={Renderer} />
              </div>
              <div className="funfact-btn funfact-btn--round-shape funfact-btn-theme btn-hover">
                <Link to={process.env.PUBLIC_URL + block?.componentData?.url}>
                  SHOP NOW
                </Link>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-6 order-2 order-lg-1">
            <div className="funfact-image">
              <Link to={process.env.PUBLIC_URL + block?.componentData?.url}>
                <img
                  src={block?.componentData?.img}
                  alt=""
                  className="img-fluid"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CountDownThree.propTypes = {
  countDownImage: PropTypes.string,
  dateTime: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default CountDownThree;
